<template>
  <v-dialog v-model="dialog" max-width="900px" persistent>
    <v-card>
      <v-card-title>
        <span color="primary" class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                dir="rtl"
                v-model="formData.arabic_title"
                :rules="textRules"
                label="arabic_title"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.english_title"
                :rules="textRules"
                label="english_description"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                dir="rtl"
                v-model="formData.arabic_description"
                label="arabic_description"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="formData.english_description"
                label="english_description"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.sequence"
                label="sequence"
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" md="6">
              <v-autocomplete
                :loading="loadingCategories"
                v-model="formData.parent_category"
                :items="categories"
                dense
                chips
                small-chips
                label="categories"
                item-text="english_title"
                item-value="id"
              ></v-autocomplete>
            </v-col> -->

            <!-- <v-col cols="12" md="6">
              <v-autocomplete
                :loading="loadingComponentTypes"
                v-model="formData.component_type_id"
                :items="component_types"
                dense
                chips
                small-chips
                label="component_types"
                item-text="title"
                item-value="id"
              ></v-autocomplete>
            </v-col> -->

            <v-col cols="12" md="6">
              <v-file-input
                v-model="image"
                chips
                multiple
                label="Select Image"
              ></v-file-input>
            </v-col>
            <!-- 
            <v-col cols="12" md="6">
              <v-color-picker
                dot-size="25"
                swatches-max-height="200"
                v-model="background_color"
              ></v-color-picker>
            </v-col> -->

            <v-col cols="12" md="6" v-if="file">
              <div class="image-area" style="margin-bottom: 10px;">
                <img
                  :src="file.data.full_url"
                  v-if="file"
                  width="250px"
                  height="250px"
                />
                <!-- @click="openLink(img.data.full_url)" -->

                <a
                  class="remove-image"
                  @click="removeimg(file.id)"
                  href="#"
                  style="display: inline;"
                  >&#215;</a
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error darken-1" text @click="close">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" text @click="submit">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar" absolute top :multi-line="true">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiService from "@/services/api.service";

export default {
  props: ["formTitle", "record", "dialog"],
  data() {
    return {
      snackbar: false,
      valid: false,
      submitted: false,
      loading: false,
      error: "",
      loadingCategories: false,
      loadingComponentTypes: false,
      formData: {
        // component_type_id: null,
        id: null,
        arabic_title: null,
        english_title: null,
        arabic_description: null,
        english_description: null,
        sequence: null,
        parent_category: 103,
        background_color: null,
        category_image: null,
      },
      parent_category: null,
      background_color: null,
      categories: [],
      // component_types: [],
      image: null,
      file: null,
      textRules: [(v) => !!v || "field is required"],

      // =================== for updating users ===================
      initialPayload: {},
    };
  },
  computed: {
    ...mapGetters(["categoryGetter", "fileGetter"]),
  },
  methods: {
    ...mapActions([
      "getCategories",
      "postCategory",
      "patchCategory",
      "deleteCategory",
      "deleteFile",
      "postFile",
      "getFile",
    ]),
    async removeimg(id) {
      await this.deleteFile(id);
      let msg;
      if (this.fileGetter.errorDeleteFile) {
        msg = this.fileGetter.errorDeleteFile;
        alert(msg);
      } else {
        // msg = "image deleted";
        this.submit();
      }
    },
    async submit() {
      try {
        if (this.$refs.form.validate()) {
          this.submitted = true;
          if (this.background_color) {
            this.formData.background_color = this.background_color.hex;
          }
          console.log(this.formData);

          if (this.image) {
            // send file
            let formData1 = new FormData();
            formData1.append("data", this.image[0]);
            await this.postFile(formData1);
            // send post req
            this.formData["category_image"] = this.fileGetter.addedFile;
          }

          if (this.record) {
            await this.patchCategory(this.formData);
            if (this.categoryGetter.errorpatchCategory) {
              this.snackbarMsg = this.categoryGetter.errorpatchCategory;
              this.snackbar = true;
            }
          } else {
            await this.postCategory(this.formData);
            if (this.categoryGetter.errorPostCategory) {
              this.snackbarMsg = this.categoryGetter.errorPostCategory;
              this.snackbar = true;
            }
          }
          this.submitted = false;
          const msg = this.record
            ? "record updated successfully"
            : "record inserted successfully";
          this.$emit("formSubmitted", msg);
        } else {
          this.snackbar = true;
          this.error = "please fill all required fields";
        }
      } catch (error) {
        if (error.message !== "") {
          this.error = error;
        } else {
          this.error = "sorry, something went wrong";
        }
        this.snackbar = true;
        console.log(error);
        this.submitted = false;
      }
    },
    close() {
      this.$emit("closeDialog");
    },
  },

  async mounted() {
    this.categories = this.categoryGetter.categories;
    console.log(this.record);
    // const component_types = await ApiService.get(
    //   "items/component_types?fields=id,title"
    // );
    // this.component_types = component_types.data.data;

    if (this.record) {
      Object.keys(this.formData).forEach((element) => {
        if (this.record[element]) {
          if (typeof this.record[element] == "object") {
            this.formData[element] = this.record[element].id;
          } else {
            this.formData[element] = this.record[element];
          }
        }
      });
      if (this.formData.category_image) {
        await this.getFile(this.formData.category_image);
        this.file = this.fileGetter.file;
      }
      if (this.formData.background_color) {
        this.background_color = this.formData.background_color;
      }
    }
  },
};
</script>
<style lang="css">
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";
@import "~quill/dist/quill.bubble.css";
.image-area {
  position: relative;
  width: 50%;
  background: #333;
}
.image-area img {
  max-width: 100%;
  height: auto;
}
.remove-image {
  display: none;
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 10em;
  padding: 2px 6px 3px;
  text-decoration: none;
  font: 700 21px/20px sans-serif;
  background: #555;
  border: 3px solid #fff;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5), inset 0 2px 4px rgba(0, 0, 0, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  -webkit-transition: background 0.5s;
  transition: background 0.5s;
}
.remove-image:hover {
  background: #e54e4e;
  padding: 3px 7px 5px;
  top: -11px;
  right: -11px;
}
.remove-image:active {
  background: #e54e4e;
  top: -10px;
  right: -11px;
}
</style>
